import React, { useContext, useEffect } from "react";
// import Sidebar from "../Sidebar/Sidebar";
// import "./updatePassword.scss";
import { useState } from "react";
import { toast } from "react-toastify";
// import UserContext from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
import SidebarFacility from "../SidebarFacility";

function FacilityChangePassword() {
  const [hideSvg, setHideSvg] = useState(false);

  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const handleInputChange = (e) => {
    setPassword({ ...password, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = `https://ballersapi.ballerslife.co/api/v1/facility_admin/update_password?new_password=${encodeURIComponent(
      password.password
    )}&confirm_new_password=${encodeURIComponent(password.confirmPassword)}`;

    const accessToken = window.localStorage.getItem("access_token");

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log(data, "daatta");
      if (response.status === 200) {
        setPassword({
          password: "",
          confirmPassword: "",
        });
        toast.success(data.message);
      } else if (response.status === 403) {
        toast.error(data.message);
      } else if (response.status === 404) {
        toast.error(data.detail);
        if (data.detail === "Passwords dont match") {
          setPassword({
            password: "",
            confirmPassword: "",
          });
        }
      } else if (response.status === 422) {
        toast.error(data.detail[0].msg);
      }
    } catch (error) {
      console.error("Error updating password:", error.message);
      toast.error("Password update failed");
    }
  };
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  useEffect(() => {
    document.title = ` Update Password | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="dashMain">
      <div className="sideBar">
        <SidebarFacility />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <SidebarFacility />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div className="user">
          <div className="svgMain" onClick={handleSvg}>
            {hideSvg ? (
              <div className="closeSvg"></div>
            ) : (
              <div className="hamburgerSvg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0F0223"
                  stroke="#eee2e2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-menu"
                >
                  <line x1="4" x2="20" y1="12" y2="12" />
                  <line x1="4" x2="20" y1="6" y2="6" />
                  <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
              </div>
            )}
          </div>

          <div className="userSec">
            {hideSvg ? (
              <div onClick={handleSvg}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0F0223"
                  stroke="#eee2e2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-x-square"
                >
                  <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                  <path d="m15 9-6 6" />
                  <path d="m9 9 6 6" />
                </svg>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <>
          <div className="updatePass">
            <div>
              <div className="updatePassSec">
                <p>New Password</p>
                <input
                  autoComplete="off"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password.password}
                  onChange={handleInputChange}
                  placeholder="Enter New Password"
                />
                <div className="showPassword">
                  {password.password.length > 0 ? (
                    <>
                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          // stroke="rgb(255, 191, 0)"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-eye-off"
                          cursor={"pointer"}
                          onClick={() => {
                            togglePasswordVisibility();
                          }}
                        >
                          <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                          <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                          <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                          <line x1="2" x2="22" y1="2" y2="22" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          // stroke="rgb(255, 191, 0)"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-eye"
                          cursor={"pointer"}
                          onClick={() => {
                            togglePasswordVisibility();
                          }}
                        >
                          <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="updatePassSec">
                <p>Confirm Password</p>
                <input
                  autoComplete="off"
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={password.confirmPassword}
                  onChange={handleInputChange}
                  placeholder="Confirm Password"
                />
                <div className="showPassword">
                  {password.confirmPassword.length > 0 ? (
                    <>
                      {showConfirmPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          // stroke="rgb(255, 191, 0)"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-eye-off"
                          cursor={"pointer"}
                          onClick={() => {
                            toggleConfirmPasswordVisibility();
                          }}
                        >
                          <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                          <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                          <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                          <line x1="2" x2="22" y1="2" y2="22" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          // stroke="rgb(255, 191, 0)"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-eye"
                          cursor={"pointer"}
                          onClick={() => {
                            toggleConfirmPasswordVisibility();
                          }}
                        >
                          <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="btnMainSec">
                <div className="updateBtn" onClick={handleSubmit}>
                  <button>Update </button>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default FacilityChangePassword;
